import { defineComponent } from '@vue/runtime-core';

export default defineComponent({
  setup() {
    return () => (
      <router-view />
    );
  },
});
